import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import OrderView from "./OrderView";
import GridConfig from "./GridConfig";
import { Header } from './Header';
import { Footer } from './Footer';

export default class OrderViews extends Base {
    constructor(props) {
        super(props);
        this.state = {
            caller: props.Caller,
            controllerName: 'orderview',
            data: null,
            loading: true,
            configName: 'orderviews_grid',
            moduleName: 'فروش ها',
            filters: {
                isMy: props.IsMy
            }
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.refreshData();
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({ component: <OrderView IsMy={this.state.filters.isMy} Caller={this} Id={id} /> });
    }
    onGridConfig() {
        this.showComponents({ component: <GridConfig Caller={this} Config={this.getGridConfig()} /> });
    }
    getDefaultConfig() {
        return {
            name: this.state.configName,
            fields: [
                { field: "typeString", caption: "موضوع فروش", show: true },
                { field: "buyerUserName", caption: "خریدار", show: true },
                { field: "sellerUserName", caption: "فروشنده", show: !this.state.filters.isMy },
                { field: "statusString", caption: "وضعیت", show: true },
                { field: "final", caption: "مبلغ کل", show: true },
                { field: "commision", caption: "کمیسیون", show: true },
                { field: "date", caption: "تاریخ ثبت", show: true }
            ]
        }
    }
    getColumns() {
        var config = this.getGridConfig();
        var t = [];
        config.fields.forEach(f => {
            if (f.field == 'typeString' && f.show) t.push({ field: f.field, headerName: f.caption, cellRenderer: (props) => { return <a className="text-primary txt-bold hand" onClick={e => this.onEdit(props.data.id)}>{props.data.typeString}</a> } });
            if (f.field == 'buyerUserName' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'sellerUserName' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'statusString' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'final' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.final) } });
            if (f.field == 'commision' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.commision) } });
            if (f.field == 'date' && f.show) t.push({ field: f.field, headerName: f.caption });
        });
        return t;
    }
    renderForm() {
        return <div className="nk-content-body">
                <div className="nk-block">
                    <div className="card card-bordered card-stretch">
                        <div className="card-inner-group">
                        <div className="card-inner p-0">
                            {this.getToolBar(false, { add: false, print: true, pdf: true, excell:true,remove:false })}
                                {this.renderAgGrid({
                                    columnDefs: this.getColumns()
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />,
                this.renderPopupComponent(),
            ];

        return contents;
    }
}